import { render, staticRenderFns } from "./DappsOverviewView.vue?vue&type=template&id=70de8f61"
import script from "./DappsOverviewView.vue?vue&type=script&lang=ts"
export * from "./DappsOverviewView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports